import { render, staticRenderFns } from "./ListaDePedidosCartao.vue?vue&type=template&id=3974ecc4&scoped=true"
import script from "./ListaDePedidosCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaDePedidosCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListaDePedidosCartao.vue?vue&type=style&index=0&id=3974ecc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3974ecc4",
  null
  
)

export default component.exports